export default __webpack_public_path__ + "static/media/aws.316da603.png";